export default __webpack_public_path__ + "static/media/good-bg.599c71df.svg";